import InstitutionFuturesClientCategorisationOnboardingForm from '@/features/institution/futures/client-categorisation/components/onboarding-form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingClientCategorisationPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="clientCategorisation" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionFuturesClientCategorisationOnboardingForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingClientCategorisationPage.displayName = 'InstitutionOnboardingClientCategorisationPage';

export default InstitutionOnboardingClientCategorisationPage;
